import LinearLoader from '#/components/Loader/Linear'

export function FormbuilderLinearLoader(props: { isLoading: boolean }) {
  return <LinearLoader loading={props.isLoading} absolute variant="indeterminate" />
}
